import type { ReactNode } from 'react';
import { MultiTariffUpsaleRadioType } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model.types';
import { MultiTariffUpsaleModelBase } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialogBase.model';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export class BusinessMultiTariffUpsaleModel extends MultiTariffUpsaleModelBase {
    private getTitleTemlate(target: string) {
        return `В\u00A0тарифе для работы больше возможностей, чем в\u00A0${target}`;
    }

    override getTitle(): ReactNode {
        switch (this.activeTab) {
            case ETabsName.basic:
                return this.getTitleTemlate('Минимальном');
            case ETabsName.advanced:
                return this.getTitleTemlate('Основном');
            default:
                return;
        }
    }

    override getTitleDescription(): ReactNode {
        switch (this.activeTab) {
            case ETabsName.basic:
                return 'Например, отключится реклама в\u00A0Mail. А\u00A0ещё сможете отменять отправленные письма и\u00A0получать уведомление о\u00A0прочтении';
            case ETabsName.advanced:
                return 'Например, сможете выбрать красивый адрес. А\u00A0ещё\u00A0- отменять отправленные письма и\u00A0получать уведомление о\u00A0прочтении';
            default:
                return;
        }
    }

    override getPriorityCardTopTitle(): ReactNode {
        const targetProduct = this.getUpsaleProduct() || this.product;
        return `+${targetProduct.space.value}`;
    }

    override getPriorityCardLabelText(): ReactNode {
        return 'Для работы';
    }

    override getSecondaryCardTopTitle(): ReactNode {
        return `+${this.product.space.value}`;
    }

    override getSecondaryCardLabelText(): ReactNode {
        switch (this.activeTab) {
            case ETabsName.basic:
                return 'Минимальный';
            case ETabsName.advanced:
                return 'Основной';
            default:
                return;
        }
    }

    override getSecondaryCardLabelVisible(): boolean {
        return true;
    }

    override getDwh(selected: MultiTariffUpsaleRadioType) {
        const dwh = super.getDwh(selected);
        const isPriority = selected === MultiTariffUpsaleRadioType.priority;
        const upsaleId = this.getUpsaleProduct()?.id;
        const productId = this.product.id;
        return {
            ...dwh,
            name: 'tariff_line_for_work',
            tariffs_line_from: this.activeTab,
            tariffs_line_to: ETabsName.for_work,
            tariff_from: productId,
            tariff_to: upsaleId,
            tariff: isPriority ? upsaleId : productId,
        };
    }
}
